import { motion } from "motion/react";

/**
 * Kokonut-UI-style "border beam" card: a light traces the card border on
 * loop. Copy-paste pattern — no dependency beyond `motion`, drop anywhere.
 */
export function BorderBeamCard({ children, className = "", beamDuration = 4, ...rest }) {
  return (
    <div className={`relative rounded-2xl overflow-hidden glass p-6 ${className}`} {...rest}>
      <div className="absolute inset-0 rounded-2xl pointer-events-none">
        <motion.div
          className="absolute inset-0 rounded-2xl"
          style={{
            background:
              "conic-gradient(from 0deg, transparent 0%, rgba(0,229,255,0.9) 8%, transparent 16%)",
            WebkitMask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
            padding: 1.5,
            maskComposite: "exclude",
            WebkitMaskComposite: "xor",
          }}
          animate={{ rotate: 360 }}
          transition={{ duration: beamDuration, repeat: Infinity, ease: "linear" }}
        />
      </div>
      <div className="relative z-10">{children}</div>
    </div>
  );
}

export default BorderBeamCard;
